<template>
  <div class="audio_selcon animated slideInLeft">
    <div class="flex_bet_h tools_titmod">
      <span class="tools_tit">选择音频</span>
      <img
        src="../../assets/images/img2/offlogin.png"
        class="tools_off"
        @click="overSelect"
      />
    </div>
    <div class="order" v-if="work_list.length==0">
        <img src="../../assets/images/null.png" alt="">
    </div>
    <div class="audio_sellist" @scroll="scrollList($event)" v-else>
      <div
        class="audio_selli"
        v-for="(item, index) in work_list"
        :key="index"
        @click="addSelestList(index)"
      >
        <img
          src="../../assets/images/pause.png"
          class="audio_selliplay"
          @click.stop="play_audio.play(item.musicpath)"
          v-if="play_audio.audiourl == item.musicpath"
        />
        <img
          class="audio_selliplay"
          src="../../assets/images/play.png"
          @click.stop="play_audio.play(item.musicpath)"
          v-else
        />
        <div class="audio_sellicon">
          <p class="overflow_hide">
            {{ item.wkname ? item.wkname : "未命名作品" }}
          </p>
          <p class="joint_mod_text joint_mod_text1 ">
            <span >{{ item.voiceauthor }}</span>
            <span class="overflow_hide wt">{{ item.bgname ? item.bgname : "无背景音" }}</span>
          </p>
        </div>
        <div class="audio_selstate" v-if="judgeInSelectList(index)"></div>
        <img
          src="../../assets/images/img2/select.png"
          class="audio_selicon"
          v-else
        />
      </div>
    </div>
    <div class="ausel_detbtn" @click="overSelect">确认选择</div>
  </div>
</template>
<script>
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  props: {
    // 是否多选
    ismore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      work_list: [], //作品列表
      page: 1, //分页页数
      lastPage: false, //是否最后一页
      play_audio: new PlayListAudio(), //播放器对象
      select_list: [], //选择的文件索引列表
    };
  },
  mounted() {
    this.getWorks(false);
  },
  computed: {
    // 判断文件是否在索引列表里面
    judgeInSelectList(index) {
      return (index) => {
        return this.select_list.indexOf(index) > -1 ? false : true;
      };
    },
  },
  destroyed() {
    this.play_audio.stop();
  },
  methods: {
    // 关闭事件
    overSelect() {
      let list = [];
      this.select_list.forEach((item) => {
        list.push(this.work_list[item]);
      });
      this.$emit("overSelect", list);
    },
    // 选择文件
    addSelestList(index) {
      if (!this.ismore) {
        this.select_list = [];
        this.select_list.push(index);
        console.log(this.select_list);
        return;
      }
      let index_in = this.select_list.indexOf(index);
      // 如果索引存在就删除不存在就添加
      index_in == -1
        ? this.select_list.push(index)
        : this.select_list.splice(index_in, 1);
    },
    // 获取作品列表
    getWorks(isadd) {
      // isadd？true=分页追加数据：false=覆盖列表数据
      let self = this;
      if (self.lastPage && isadd) return;
      if (isadd) this.page += 1;
      let json = {
        page: this.page,
        rows: 10,
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryworklist;
      this.$request.postHttp(json, url, (decData) => {
        self.lastPage = decData.model.lastPage;
        if (isadd) {
          self.work_list = self.work_list.concat(decData.model.list);
        } else {
          self.work_list = decData.model.list;
        }
      });
    },
    // 滑动触底事件
    scrollList(e) {
      const dom = e.target;
      var scrollTop = dom.scrollTop; //滑入屏幕上方的高度
      var windowHeitht = dom.clientHeight; //能看到的页面的高度
      var scrollHeight = dom.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht;
      if (total == scrollHeight) {
        this.getWorks(true);
      }
    },
  },
};
</script>


<style scoped>
@import url("../../assets/css/tools.css");
.wt{
    width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/tools/audio_select.vue